











import {SfHeading} from '@storefront-ui/vue';
import {defineComponent} from "@nuxtjs/composition-api";

export default defineComponent({
  name: 'CmsPage',
  components: {
    SfHeading,
  }
});
